"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeductFrom = exports.FiscalYear = exports.RefreshPeriod = exports.NotifySenderType = exports.NotifyTeamAdminType = exports.PauseGiftingOnOption = exports.BudgetType = exports.BudgetCreateField = void 0;
var BudgetCreateField;
exports.BudgetCreateField = BudgetCreateField;

(function (BudgetCreateField) {
  BudgetCreateField["Amount"] = "amount";
  BudgetCreateField["Type"] = "type";
  BudgetCreateField["RefreshPeriod"] = "period";
  BudgetCreateField["FiscalYear"] = "fiscalYear";
  BudgetCreateField["DeductFrom"] = "deductFrom";
  BudgetCreateField["RefreshSelected"] = "isRefreshSelected";
  BudgetCreateField["BudgetSet"] = "isBudgetSet";
  BudgetCreateField["PauseOption"] = "pauseGiftingOn";
  BudgetCreateField["TeamMemberBudgets"] = "teamMembers";
  BudgetCreateField["Rollover"] = "rollover";
  BudgetCreateField["NotifyTeamAdminType"] = "notifyTeamAdminType";
  BudgetCreateField["NotifySenderType"] = "notifySenderType";
  BudgetCreateField["NotifySenderAtPercent"] = "notifySenderAtPercent";
  BudgetCreateField["NotifyTeamAdminAtPercent"] = "notifyTeamAdminAtPercent";
})(BudgetCreateField || (exports.BudgetCreateField = BudgetCreateField = {}));

var BudgetType;
exports.BudgetType = BudgetType;

(function (BudgetType) {
  BudgetType["User"] = "user";
  BudgetType["Team"] = "team";
})(BudgetType || (exports.BudgetType = BudgetType = {}));

var PauseGiftingOnOption;
exports.PauseGiftingOnOption = PauseGiftingOnOption;

(function (PauseGiftingOnOption) {
  PauseGiftingOnOption["Claimed"] = "claimed";
  PauseGiftingOnOption["Sent"] = "sent";
})(PauseGiftingOnOption || (exports.PauseGiftingOnOption = PauseGiftingOnOption = {}));

var NotifyTeamAdminType;
exports.NotifyTeamAdminType = NotifyTeamAdminType;

(function (NotifyTeamAdminType) {
  NotifyTeamAdminType["EveryUsed"] = "every_used";
  NotifyTeamAdminType["OnceUsed"] = "once_used";
  NotifyTeamAdminType["OnceRemaining"] = "once_remaining";
})(NotifyTeamAdminType || (exports.NotifyTeamAdminType = NotifyTeamAdminType = {}));

var NotifySenderType;
exports.NotifySenderType = NotifySenderType;

(function (NotifySenderType) {
  NotifySenderType["EveryUsed"] = "every_used";
  NotifySenderType["OnceUsed"] = "once_used";
  NotifySenderType["OnceRemaining"] = "once_remaining";
})(NotifySenderType || (exports.NotifySenderType = NotifySenderType = {}));

var RefreshPeriod;
exports.RefreshPeriod = RefreshPeriod;

(function (RefreshPeriod) {
  RefreshPeriod["Weekly"] = "weekly";
  RefreshPeriod["Monthly"] = "monthly";
  RefreshPeriod["Quarterly"] = "quarterly";
  RefreshPeriod["Annually"] = "annually";
  RefreshPeriod["NoReset"] = "no reset";
})(RefreshPeriod || (exports.RefreshPeriod = RefreshPeriod = {}));

var FiscalYear;
exports.FiscalYear = FiscalYear;

(function (FiscalYear) {
  FiscalYear[FiscalYear["January"] = 1] = "January";
  FiscalYear[FiscalYear["February"] = 2] = "February";
  FiscalYear[FiscalYear["March"] = 3] = "March";
  FiscalYear[FiscalYear["April"] = 4] = "April";
  FiscalYear[FiscalYear["May"] = 5] = "May";
  FiscalYear[FiscalYear["June"] = 6] = "June";
  FiscalYear[FiscalYear["July"] = 7] = "July";
  FiscalYear[FiscalYear["August"] = 8] = "August";
  FiscalYear[FiscalYear["September"] = 9] = "September";
  FiscalYear[FiscalYear["October"] = 10] = "October";
  FiscalYear[FiscalYear["November"] = 11] = "November";
  FiscalYear[FiscalYear["December"] = 12] = "December";
})(FiscalYear || (exports.FiscalYear = FiscalYear = {}));

var DeductFrom;
exports.DeductFrom = DeductFrom;

(function (DeductFrom) {
  DeductFrom["SENDER"] = "sender";
  DeductFrom["SEND_AS"] = "send_as";
})(DeductFrom || (exports.DeductFrom = DeductFrom = {}));